import AddOn from './AddOn';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import { replaceRichText } from 'src/common/utils/text-replace';

const enhance = compose(
  withProps(props => ({
    description: replaceRichText(props.description, props.productCustomisation)
  })),
  withHandlers({
    handleLookInsideMain: props => () => {
      if (!props.selected) {
        props.handleOnChange();
      }
    },
    handleLookInsideCancel: props => () => {
      if (props.selected) {
        props.handleOnChange();
      }
    },
  })
);

export default enhance(AddOn);



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddOns/AddOn/index.js